import { actionCreator } from '@ardoq/rxbeach';
import {
  APICurrentUserConfidentialFieldPermissions,
  APICurrentUserPermission,
  ArdoqId,
} from '@ardoq/api-types';
import { AddApiResourcePermissionAttributePayload } from '@ardoq/access-control';

export const apiFetchCurrentUserPermissions = actionCreator(
  '[currentUserPermissions] FETCH_CURRENT_USER_PERMISSIONS'
);

export const resetCurrentUserPermissions = actionCreator(
  '[currentUserPermissions] RESET_CURRENT_USER_PERMISSIONS'
);

export const fetchedCurrentUserPermissions = actionCreator<
  APICurrentUserPermission[]
>('[currentUserPermissions] FETCHED_CURRENT_USER_PERMISSIONS');

export const failedFetchCurrentUserPermissions = actionCreator<unknown>(
  '[currentUserPermissions] FAILED_FETCH_CURRENT_USER_PERMISSIONS'
);

export const addPermissionForResource =
  actionCreator<AddApiResourcePermissionAttributePayload>(
    '[currentUserPermissions] ADD_PERMISSION_FOR_RESOURCE'
  );

export const confidentialFieldsReceived =
  actionCreator<APICurrentUserConfidentialFieldPermissions>(
    '[currentUser] CONFIDENTIAL_FIELDS_RECEIVED'
  );

/**
 * Notifies of workspaces that need to be reloaded if they are currently loaded
 * because confidential field permissions have changed. If a dataset was loded
 * without permission to a field, then the permission was granted, the dataset
 * will be out of sync with what the server has and risks overwriting data.
 * The other way around means they are seeing confidential data they should not
 * have access to.
 */
export const reloadWorkspacesDueToFieldPermissionChangesRequested =
  actionCreator<ArdoqId[]>(
    '[currentUserPermissions] RELOAD_WORKSPACES_DUE_TO_FIELD_PERMISSION_CHANGES_REQUESTED'
  );
